import React from 'react';
import styled from 'styled-components';

const ServicesContainer = styled.section`
  padding: 80px 2rem;
  background: ${props => props.theme.colors.background};
`;

const ServicesContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2.8rem;
  color: ${props => props.theme.colors.textWarm};
  margin-bottom: 1rem;
  font-family: ${props => props.theme.fonts.accent};
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.5rem;
  color: ${props => props.theme.colors.text};
  margin-bottom: 4rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 300;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
  margin-bottom: 4rem;
`;

const ServiceCard = styled.div`
  background: ${props => props.theme.colors.backgroundLight};
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid ${props => props.theme.colors.borderLight};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  }
`;

const ServiceIcon = styled.div`
  width: 60px;
  height: 60px;
  background: ${props => props.theme.colors.primary};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 1.8rem;
  color: white;
`;

const ServiceTitle = styled.h3`
  font-size: 1.7rem;
  color: ${props => props.theme.colors.textWarm};
  margin-bottom: 1rem;
  font-weight: 600;
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.text};
  margin-bottom: 1.5rem;
  font-weight: 300;
`;

const AdditionalNote = styled.p`
  font-size: 1.4rem;
  color: ${props => props.theme.colors.text};
  text-align: center;
  margin-top: 2rem;
  font-weight: 300;
  font-style: italic;
`;

const Services: React.FC = () => {
  return (
    <ServicesContainer id="services" aria-labelledby="services-title">
      <ServicesContent>
        <SectionTitle id="services-title">איך אני יכולה לעזור?</SectionTitle>
        <SectionSubtitle>
          המענים הטיפוליים שאני מציעה כוללים, בין היתר: טיפול פסיכולוגי בילדים ובמתבגרים, הדרכת הורים, טיפול בהורות ועוד
        </SectionSubtitle>

        <ServicesGrid role="list" aria-label="רשימת שירותים">
          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">◆</ServiceIcon>
            <ServiceTitle>קושי בביטחון העצמי ודימוי עצמי נמוך</ServiceTitle>
            <ServiceDescription>
              ליווי ילדים ומתבגרים לבניית דימוי עצמי חיובי וחיזוק הביטחון העצמי הפנימי.
            </ServiceDescription>
          </ServiceCard>

          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">●</ServiceIcon>
            <ServiceTitle>קשיים במיומנויות חברתיות</ServiceTitle>
            <ServiceDescription>
              פיתוח כישורים חברתיים ויכולת יצירת קשרים איכותיים עם בני גיל.
            </ServiceDescription>
          </ServiceCard>

          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">■</ServiceIcon>
            <ServiceTitle>קשיי הסתגלות במסגרת הלימודית</ServiceTitle>
            <ServiceDescription>
              תמיכה בהתמודדות עם אתגרים במסגרת החינוכית וחיזוק התפקוד הלימודי.
            </ServiceDescription>
          </ServiceCard>

          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">▲</ServiceIcon>
            <ServiceTitle>קשיי התנהגות</ServiceTitle>
            <ServiceDescription>
              עבודה על ויסות התנהגות ופיתוח אסטרטגיות התמודדות יעילות.
            </ServiceDescription>
          </ServiceCard>

          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">◆</ServiceIcon>
            <ServiceTitle>קשיים בוויסות רגשי</ServiceTitle>
            <ServiceDescription>
             מתן כלים לזיהוי, הבנה וביטוי רגשות בצורה מיטיבה.
            </ServiceDescription>
          </ServiceCard>

          <ServiceCard role="listitem">
            <ServiceIcon aria-hidden="true">●</ServiceIcon>
            <ServiceTitle>קשר הורה-ילד/ה</ServiceTitle>
            <ServiceDescription>
              חיזוק הקשר המשפחתי ושיפור התקשורת בין הורים לילדים.
            </ServiceDescription>
          </ServiceCard>
        </ServicesGrid>

        <AdditionalNote>
          מוזמנים לפנות אליי עבור שירותים נוספים או התאמה אישית לצרכים שלכם.
        </AdditionalNote>
      </ServicesContent>
    </ServicesContainer>
  );
};

export default Services;